var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfind-page"},[_c('img',{attrs:{"src":require("../../static/images/404.png")}}),_c('el-button',{attrs:{"type":"primary","round":""},on:{"click":_vm.gotoIndex}},[_vm._v(_vm._s(_vm.$t('common.notfind_page_btn_1')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }